'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var constants = require('./constants-0cf35288.js');
require('react');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./svg-icon-501cae97.js');
require('./pill-89b3b361.js');
var formField = require('./form-field-8601b6d9.js');
require('./asterisk-436ee6b3.js');
require('./field-label-4ed9b7f8.js');
require('./field-hint-cc714695.js');
require('./messages-f8f39369.js');
require('./loader-8f6b1e8c.js');
require('./select-6c9d108c.js');
require('./select-item-7fd13c43.js');
require('./select-title-65885e9f.js');
var button = require('./button-c50f4784.js');
require('./calendar-date.styles-9072cd1e.js');
require('./styles-20009c57.js');
require('./index.esm-c41adfff.js');
require('./fa-icon-d6ca067a.js');
require('./field.styles-a36bbd7b.js');
require('./styles-424066e0.js');
require('./overlay-878554b6.js');
require('./paper-e6cfe656.js');
require('./style-0cb3d1f5.js');
require('./styles-558f9987.js');
require('./native-select.styles-3602a739.js');
require('./select-wrapper.styles-0104a777.js');
require('./device.context-f96381a3.js');
require('./mobile-detect-2421ba00.js');
require('./styles-38df6401.js');
require('./styles-f287cb5d.js');
require('./status-indicator-57cc71fd.js');
require('./styles-6fa8f6cf.js');
require('./text-break-b3fca248.js');
require('./tooltip-8d9d80ea.js');
var fileUpload = require('./file-upload-00a5afcb.js');

var SUBJECT_CHARLEN = 255;
var DESC_CHARLEN = 32000;
var FILETYPES = '.pdf, .jpg, png, .doc, .docx, .mov, .mpg, .xlsx';
var FILE_LIMIT = 5;
var MAX_SIZE_PER_FILE = 5;
var MAX_SIZE_TOTAL = 25;
var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  position: relative;\n  overflow-y: auto;\n\n  @media screen and (max-width: ", ") {\n    height: calc(100vh - 65px);\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  position: relative;\n  overflow-y: auto;\n\n  @media screen and (max-width: ", ") {\n    height: calc(100vh - 65px);\n  }\n"])), constants.DIMENSIONS.MEDIUM);
var ScrollableContainer = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin-bottom: 40px;\n  padding-bottom: 40px;\n  overflow-y: auto;\n\n  @media screen and (max-width: ", ") {\n    margin-bottom: 5px;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin-bottom: 40px;\n  padding-bottom: 40px;\n  overflow-y: auto;\n\n  @media screen and (max-width: ", ") {\n    margin-bottom: 5px;\n  }\n"])), constants.DIMENSIONS.MEDIUM);
var SubjectFormField = styled__default(formField.FormField)(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  margin-top: 25px;\n"], ["\n  margin-top: 25px;\n"])));
var DescriptionFormField = styled__default(SubjectFormField)(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  margin-top: 10px;\n"], ["\n  margin-top: 10px;\n"])));
var Upload = styled__default(fileUpload.FileUpload)(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  margin-top: 20px;\n"], ["\n  margin-top: 20px;\n"])));
var SubmitButton = styled__default(button.Button)(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n  @media screen and (max-width: ", ") {\n    display: none;\n  }\n"], ["\n  @media screen and (max-width: ", ") {\n    display: none;\n  }\n"])), constants.DIMENSIONS.MEDIUM);
var CancelButton = styled__default(SubmitButton)(templateObject_7 || (templateObject_7 = tslib_es6.__makeTemplateObject(["\n  margin-left: 35px;\n  color: ", ";\n  border: ", ";\n"], ["\n  margin-left: 35px;\n  color: ", ";\n  border: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.sharedDarkGrey;
}, function (_a) {
    var theme = _a.theme;
    return "1px " + theme.colors.greys.sharedDarkGrey + " solid";
});
var MobileButton = styled__default(button.Button)(templateObject_8 || (templateObject_8 = tslib_es6.__makeTemplateObject(["\n  display: none;\n\n  @media screen and (max-width: ", ") {\n    align-self: flex-end;\n    display: flex;\n    height: 50px;\n    bottom: 15px;\n    width: 100%;\n  }\n"], ["\n  display: none;\n\n  @media screen and (max-width: ", ") {\n    align-self: flex-end;\n    display: flex;\n    height: 50px;\n    bottom: 15px;\n    width: 100%;\n  }\n"])), constants.DIMENSIONS.MEDIUM);
var ButtonContainer = styled__default.div(templateObject_9 || (templateObject_9 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  bottom: 0;\n  position: absolute;\n  justify-content: flex-start;\n  flex-direction: row;\n  margin-top: 40px;\n"], ["\n  display: flex;\n  width: 100%;\n  bottom: 0;\n  position: absolute;\n  justify-content: flex-start;\n  flex-direction: row;\n  margin-top: 40px;\n"])));
var Title = styled__default.div(templateObject_10 || (templateObject_10 = tslib_es6.__makeTemplateObject(["\n  font: 500 24px/24px ", ";\n  color: ", ";\n"], ["\n  font: 500 24px/24px ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
});
var GeneralNature = styled__default.div(templateObject_11 || (templateObject_11 = tslib_es6.__makeTemplateObject(["\n  font: normal 14px/22px ", ";\n  color: ", ";\n"], ["\n  font: normal 14px/22px ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.$greyDark;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;

exports.ButtonContainer = ButtonContainer;
exports.CancelButton = CancelButton;
exports.Container = Container;
exports.DESC_CHARLEN = DESC_CHARLEN;
exports.DescriptionFormField = DescriptionFormField;
exports.FILETYPES = FILETYPES;
exports.FILE_LIMIT = FILE_LIMIT;
exports.GeneralNature = GeneralNature;
exports.MAX_SIZE_PER_FILE = MAX_SIZE_PER_FILE;
exports.MAX_SIZE_TOTAL = MAX_SIZE_TOTAL;
exports.MobileButton = MobileButton;
exports.SUBJECT_CHARLEN = SUBJECT_CHARLEN;
exports.ScrollableContainer = ScrollableContainer;
exports.SubjectFormField = SubjectFormField;
exports.SubmitButton = SubmitButton;
exports.Title = Title;
exports.Upload = Upload;
